module.exports = __webpack_public_path__ + "img/sequoia.1e41611d.png";